<template>
  <role-form
    :role="role"
    :submit="submit"
    :onInput="onInput"
    :loading="loading"
    :buttonText="$t('save')"
    :title="$t('editRoleTitle', { role: role.name })"
    :disabled="!auth.check('edit role')"
  />
</template>

<script setup lang="ts">
import { ref, computed, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import Say from '@/utils/Say';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import sayErrorResponse from '@/mixins/sayErrorResponse';
import { useAuth } from '@/utils/auth';
import RoleForm from './Form.vue';

const loading = ref(false);
const store = useStore();
const { t } = useI18n();
const route = useRoute();
const auth = useAuth();

const role = computed(() => store.getters.roleEdit);

const onInput = (name: string, value: any) => {
  if (name === 'name') store.commit('roles.editNameInput', value);
  if (name === 'permissions') store.commit('roles.editPermissionsInput', value);
};

onBeforeMount(async () => {
  await store.dispatch('permissions.fetch');
  await store.dispatch('roles.getSingleForEdit', route.params.id);

  store.commit('app.setPageTitle', 'Edit ' + store.getters.roleEdit.name);
  store.commit('app.setBreadcrumbs', [
    { text: t('role', 2), routeName: 'Roles' },
    { text: t('edit') + ' ' + store.getters.roleEdit.name }
  ]);
});

const submit = () => {
  loading.value = true;

  store.dispatch('roles.updateRole')
    .then(() => {
      // Display success
      loading.value = false;
      Say('success', t('rolePermissionsSaved'));
    })
    .catch(err => {
      loading.value = false;
      sayErrorResponse(err)
    });
};
</script>
